angular.module("Main").controller("PaymentPayPalKursSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$window", "$localStorage", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $window, $localStorage, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            //unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;
        vm.isPayPal = true;
        vm.isPayed = true;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = true;
        vm.isTermin = false;
        vm.bookingLost = false;

        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (status.status === 'TIMEOUT') {
                    vm.bookingLost = true;
                    vm.cashBack = false;
                } else {
                    if (!_.isNil($stateParams.isBlock)) {
                        BookingService.getBlockkursTermine($stateParams.bNr).then(function (data) {
                            vm.hasBlockkurse = true;
                            vm.blockkurse = data;
                            _.forEach(vm.blockkurse, function (d) {
                                d.Tag = new Date(d.Start);
                                d.Tag = moment(d.Tag).format('YYYY-MM-DD').toString();
                                d.Start = moment(d.Start).format('HH:mm').toString();
                                d.Ende = moment(d.Ende).format('HH:mm').toString();
                            });

                        }).then(function () {
                            vm.kursDataModel = ({
                                OrderNr: $stateParams.oid,
                                Bezeichnung: vm.status.artikel,
                                PreisZahl: vm.status.preis,
                                Blockkurse: vm.blockkurse,
                                PersonNr: vm.status.personNr,
                                RessourcenIds: vm.status.ressourcesIds,
                                TerminNr: vm.status.terminNr,
                                Bezahlung: vm.status.bezahlung,
                                RechnungsNr: vm.status.RechnungsNr
                            });
                        })
                    } else {

                        vm.kursDataModel = ({
                            OrderNr: $stateParams.oid,
                            Bezeichnung: vm.status.artikel,
                            PreisZahl: vm.status.preis,
                            Start: vm.status.start,
                            Ende: vm.status.ende,
                            PersonNr: vm.status.personNr,
                            RessourcenIds: vm.status.ressourcesIds,
                            TerminNr: vm.status.terminNr,
                            Bezahlung: vm.status.bezahlung,
                            RechnungsNr: vm.status.RechnungsNr
                        });
                    }


                    if (status.status !== 'CAPTURED') {

                        PaymentService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                            vm.isPayment = true;
                            vm.zahlmethode = 'PayPal';
                            if ((data && !_.isEmpty(data.rechnungsNr))) {
                                vm.kursDataModel.RechnungsNr = data.rechnungsNr;
                            }
                            if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                                vm.kursDataModel.RechnungsNr = data.data.rechnungsNr;
                            }
                        }).catch(function (error) {
                            $state.go("payment_pp_fail_kurs", {
                                cid: $stateParams.cid,
                                message: error,
                                id: $stateParams.id,
                                oid: $stateParams.oid,
                                isKurs: true
                            });
                            vm.hasError = true;
                            throw error;
                        }).then(function () {
                            getDataByRIDForConfirm();
                            PaymentService.capturePaymentPayPal($stateParams.oid).then(function () {
                                vm.captured = true;
                                BookingService.saveAppointmentHistory(vm.kursDataModel.TerminNr, 8, 4,
                                    {orderId: $stateParams.oid});
                            }).catch(function (error) {

                            })
                        });
                    } else {
                        vm.kursDataModel.RechnungsNr = vm.status.RechnungsNr;
                        vm.kursDataModel.BookingNr = vm.status.BookingNr;
                        vm.kursData = vm.kursDataModel;
                        vm.isPayment = true;
                        vm.zahlmethode = 'PayPal';
                        getDataByRIDForConfirm();
                    }
                }
            });

            vm.remindLocalePayment = $stateParams.locale;
        }

        vm.goto = function () {
            $state.go("kursplan", {sid: SessionService.getSessionId(), cid: $scope.cid, id: $scope.id});
        };

        function getDataByRIDForConfirm() {
            vm.member = {};
            vm.personNr = vm.kursDataModel.PersonNr;
            let userData = $localStorage.user;
            SessionService.setAuthData($stateParams.cid);
            BookingService.getUserDetails(userData.uid).then(function (data) {
                vm.memberNr = vm.personNr;
                vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
                vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
                vm.member = $localStorage.user;
                vm.member.firstname = $localStorage.user.Firstname;
                vm.member.lastname = $localStorage.user.Lastname;
                vm.member.email = $localStorage.user.Email;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                var arr = vm.kursDataModel.RessourcenIds.slice(1, -1);
                var ids = _.split(arr, '"');
                BookingService.getResourceNamesPayPal(ids).then(function (data) {
                    vm.ressources = _.join(_.map(_.sortBy(data, "Bezeichnung"),  "Bezeichnung"), " ,");
                }).then(function () {
                    vm.kursData = vm.kursDataModel;
                })
            });

        }

    }

])
;
